import type { ReactNode } from "react";
import { List, Menu, SwipeableDrawer } from "@mui/material";
import type { MenuProps } from "@mui/material/Menu";
import BottomSheetHandle from "shared/ui/BottomSheetHandle";
import {
    bottomSheetContentSx,
    bottomSheetPaperSx,
} from "shared/ui/bottomSheetStyles";
import { useBreakpoint } from "shared/hooks/useBreakpoint";

export type ResponsiveMenuProps = MenuProps;

export default function ResponsiveMenu({
    anchorEl,
    open,
    onClose,
    children,
    slotProps,
    ...menuProps
}: ResponsiveMenuProps) {
    const { isDesktop } = useBreakpoint();
    const isOpen = open ?? Boolean(anchorEl);

    if (isDesktop) {
        return (
            <Menu
                anchorEl={anchorEl}
                open={isOpen}
                onClose={onClose}
                slotProps={slotProps}
                {...menuProps}
            >
                {children}
            </Menu>
        );
    }

    const handleDrawerClose = () => {
        onClose?.({}, "backdropClick");
    };

    return (
        <SwipeableDrawer
            anchor="bottom"
            open={isOpen}
            onClose={handleDrawerClose}
            onOpen={() => {}}
            disableSwipeToOpen
            slotProps={{
                paper: {
                    elevation: 8,
                    sx: bottomSheetPaperSx,
                },
            }}
        >
            <BottomSheetHandle />
            <List sx={bottomSheetContentSx} disablePadding>
                {children as ReactNode}
            </List>
        </SwipeableDrawer>
    );
}
